import {Grid2 as Grid, useTheme} from "@mui/material";
import {DealsTable} from "./table";
import {Title5} from "../../../domains/common/components/Typography";
import React, {useContext} from "react";
import {DealsPageContext} from "../index";

export const DealsList = () => {
  const theme = useTheme();

  return (
    <Grid size={12} container spacing={0} sx={{maxWidth: 1421}}>
      <DealsTable/>
    </Grid>
  )
}